/**
 * The tags that make the portal installable as an app, set per brand at
 * runtime — the same way App.js already sets the favicon and title. Chrome
 * reads the manifest for its install prompt; iOS Safari reads the touch icon
 * and the title when the patient adds the page to the home screen.
 *
 * Paths are relative to the public folder; absolute and data: URLs (tenant
 * logos, the tenant's generated manifest) are used as they are.
 */
const withBase = (path) =>
  /^(https?:|data:)/.test(path) ? path : `${process.env.PUBLIC_URL || ""}${path}`;

export function applyPwaLinks(brand) {
  if (typeof document === "undefined" || !brand) return;

  const ensureLink = (rel) => {
    let element = document.querySelector(`link[rel="${rel}"]`);
    if (!element) {
      element = document.createElement("link");
      element.rel = rel;
      document.head.appendChild(element);
    }
    return element;
  };

  const ensureMeta = (name) => {
    let element = document.querySelector(`meta[name="${name}"]`);
    if (!element) {
      element = document.createElement("meta");
      element.name = name;
      document.head.appendChild(element);
    }
    return element;
  };

  ensureLink("manifest").href = withBase(brand.manifest || "/manifest.json");
  ensureLink("apple-touch-icon").href = withBase(brand.appleTouchIcon || "/logo192.png");
  ensureMeta("apple-mobile-web-app-title").content = brand.name || "sophyapp";
}

export function setFavicon(href) {
  if (typeof document === "undefined" || !href) return;
  const links = document.querySelectorAll("link[rel~='icon']");
  if (links.length === 0) {
    const link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
    link.href = href;
    return;
  }
  links.forEach((link) => {
    link.href = href;
  });
}
